module.exports = __webpack_public_path__ + "img/8c1efd9.png";